import { SingService } from "app/components/service/sing.service";
import { Injectable } from "@angular/core";
import { Expense } from "app/components/class/expense/expense";

@Injectable()
export class ActionsService {
    constructor(private httpService: SingService) {

    }
    public saveExpense (expense:Expense) {
        return this.httpService.saveExpense(expense);
    }
    public addExpense (expense:Expense) {
        return  this.httpService.addExpense(expense);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/budget/info-budget/services/actions.service.ts